import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { StatusMessageProvider } from './routes/layout/StatusMessage';
import LanguageWrapper from './routes/layout/LanguageWrapper';
import Layout from './routes/layout/Layout';
import { LanguageProvider } from '../lib/i18n/LanguageProvider';
import { HelmetProvider } from 'react-helmet-async';
import { getStorageLang } from '../stores/Language';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; // Toast bildirimleri için stil dosyasını ekleyin
import PageNotFound from './routes/pages/PageNotFound';
import Company from './routes/pages/Company';
import Topic from './routes/pages/Topic';

const App: React.FC = () => {
    const storedLang = getStorageLang() || 'tr-TR'; // Kullanıcının dilini localStorage'dan al

    return (
        <HelmetProvider>
            <StatusMessageProvider>
                <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                    {/* Router v7'ye geçiyor. Dokümantasyon incelenmeli: https://reactrouter.com/en/6.27.0/upgrading/future#v7_starttransition */}
                    <LanguageProvider>

                        <Routes>
                            {/* Boş path durumunda kullanıcının diline yönlendirme yap */}
                            <Route path="/" element={<Navigate to={`/${storedLang}`} replace />} />

                            {/* Dil parametresi olan rotalar */}
                            <Route path="/:lang/*" element={

                                <LanguageWrapper>
                                    <Layout />
                                </LanguageWrapper>

                            }>

                                <Route path="Company" element={<Company />} />
                                <Route path="Topic" element={<Topic />} />

                                <Route path="*" element={<PageNotFound />} />
                            </Route>
                        </Routes>
                        <ToastContainer position="top-right" autoClose={3000} />

                    </LanguageProvider>
                </Router>
            </StatusMessageProvider>
        </HelmetProvider>
    );
};

export default App;
